var React = require('react');

function DocumentPencil60px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M59.869 12.987l.001.005-.001.005-.003 36.269v.01c0 .073-.027.137-.041.205-.013.059-.011.118-.034.175l-.003.006a.008.008 0 0 1-.002.004l-3.974 9.65a.994.994 0 1 1-1.841 0l-3.987-9.659a.993.993 0 0 1 .016-.788V13.367a.815.815 0 0 1-.092-.375c0-.136.034-.268.092-.391v-7.19a.98.98 0 0 1-.092-.409c0-2.753 2.235-4.994 4.983-4.994 2.743 0 4.975 2.241 4.975 4.994 0 .037-.017.068-.021.104.006.042.025.079.025.123l-.001 7.758zM58 5.463a.978.978 0 0 1-.126-.461 2.993 2.993 0 0 0-2.983-2.996c-1.542 0-2.801 1.18-2.959 2.684.033.075.068.149.068.249v6.999h6V5.463zm0 8.477h-6v34.999c0 .078-.033.166-.053.25l2.943 7.131 3.059-7.426c.012-.029.036-.048.051-.076V13.94zM41.833 59.933H2.002a2.014 2.014 0 0 1-2.009-2.014V2.023C-.007.912.894.008 2.002.008H26.89c.022 0 .04.012.062.013.09.006.177.023.262.053.032.011.064.02.095.034a.995.995 0 0 1 .274.185l.013.01 15.789 15.829c.339.161.615.444.615.808v40.999c0 1.103-1.068 1.994-2.167 1.994zM1.985 57.919l40.015.02v-40H27c-.55 0-1-.448-1-.999V2.006H2.002l-.017 55.913zM28 2.939v13h13l-13-13z","key":1})]);
}

DocumentPencil60px.displayName = "DocumentPencil60px";

DocumentPencil60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.88 59.94"};

module.exports = DocumentPencil60px;

DocumentPencil60px.default = DocumentPencil60px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/document-pencil-60px.svg
// module id = 1190
// module chunks = 0